import axios from 'axios';
import { api } from "../utils/config";

const profile = async (token) => {
  try {
    const res = await axios.get(`${api}/users/profile`, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      withCredentials: true,  // Permite o envio de cookies assinados
    });

    return res.data;
    
  } catch (error) {
    console.error("Erro ao obter perfil:", error);
    throw error;
  }
};

const getAllUsers = async () => {
  try {
    const res = await axios.get(`${api}/ranking/`)

    return res.data;
    
  } catch (error) {
    console.error("Erro ao obter jogadores:", error);
    throw error;
  }
};

const updateUserCoins = async (data) => {
  try {
    
    const res = await axios.put(`${api}/users/coins/`, data, 
      {withCredentials: true},
    );

    if(res.data){
      return res.data
    }else{
      return res.response.data;
    }

  } catch (error) {
    console.error("Erro ao adicionar moedas:", error);
    throw error;
  }
}

const updateProfile = async (data) => {
  try {
    
    const res = await axios.put(`${api}/users/`, data, 
      {withCredentials: true},
    );

    if(res.data){
      return res.data
    }else{
      return res.response.data;
    }

  } catch (error) {
    console.error("Erro ao salvar perfil:", error);
    throw error;
  }
}

const userService = {
  profile,
  updateProfile,
  getAllUsers,
  updateUserCoins
};

export default userService;